const accountOrders = () => {
  const detailsManager = (e) => {
    e.preventDefault();
    const button = e.currentTarget;
    const currentOrder = e.currentTarget.parentNode.parentNode;

    if (currentOrder) {
      if (currentOrder.classList.contains('opened')) {
        currentOrder.classList.remove('opened');
        button.textContent = 'Voir le détail';
      }
      else {
        currentOrder.classList.add('opened');
        button.textContent = 'Masquer le détail';
      }
    }
    else {
      console.error('error:', currentOrder);
    }
  };

  const attachEventListener = (order) => order.addEventListener('click', detailsManager) ;

  const init = () => {
    const ordersContainer = document.querySelector('.orders');

    if (ordersContainer) {
      const orders = ordersContainer.querySelectorAll('.order');
      if (orders) {
        orders.forEach(order => {
          const detailsButton = order.querySelector('.open-details');
          if (detailsButton) {
            attachEventListener(detailsButton);
          }
        });
      }
    }
  };

  init();
};

export default accountOrders;
